import { CSSZAddress, CSSZSystemAddress } from '../Interfaces/CSSZ.interface';
import { DeepPartial } from '../../../Interfaces/DeepPartial';
import { SelectValue } from '../../../Components/Base/Select/Select';

export const formatCSSZAddress = (
	address: DeepPartial<CSSZAddress>,
): string => {
	const {
		street,
		descriptiveNumber,
		guideNumber,
		postCode,
		city,
		partOfCity,
		state,
	} = address;

	const streetPart = [
		street,
		descriptiveNumber && guideNumber
			? `${descriptiveNumber}/${guideNumber}`
			: descriptiveNumber || guideNumber,
	]
		.filter(Boolean)
		.join(' ');

	const cityPart = [postCode, city].filter(Boolean).join(' ');
	return [streetPart, cityPart, partOfCity, state?.label]
		.filter(Boolean)
		.join(', ');
};

export const isCSSZAddressComplete = (
	address?: DeepPartial<CSSZAddress> | null,
): boolean => {
	if (!address) return false;

	const hasText = (value?: string) =>
		typeof value === 'string' && value.trim().length > 0;

	const hasSelectValue = (value?: DeepPartial<SelectValue>) =>
		!!value && hasText(value.value as string);

	return (
		hasText(address.descriptiveNumber) &&
		hasText(address.postCode) &&
		hasText(address.city) &&
		hasSelectValue(address.state)
	);
};

export const formatCSSZSystemAddress = (address: CSSZSystemAddress) => {
	return formatCSSZAddress({
		...address,
		state: {
			label: address.state,
		},
	});
};
